/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} />
      <div>
        <main>{children}</main>
        <footer
          style={{
            borderTop: "1px solid #191919",
            background: "black",
            color: "white",
          }}
        >
          <div
            style={{
              margin: `0 auto`,
              maxWidth: 960,
              padding: `1.5rem`,
              fontSize: "1rem",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            className={"flex"}
          >
            <img
              src="logo37.png"
              alt="Relatable Role Models"
              width={"130"}
              style={{ marginBottom: 0 }}
            />
            <div>
              © {new Date().getFullYear()}, Relatable Role Models CIC. Company
              Number 11536725
            </div>
          </div>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
